"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pBoolToData = void 0;
var plutus_data_1 = require("@harmoniclabs/plutus-data");
var types_1 = require("../../../type_system/types.js");
var bool_1 = require("../../builtins/bool/index.js");
var phoist_1 = require("../../phoist.js");
var plam_1 = require("../../plam.js");
var minimal_1 = require("../../punsafeConvertType/minimal.js");
var pData_1 = require("../data/pData.js");
exports.pBoolToData = (0, phoist_1.phoist)((0, plam_1.plam)(types_1.bool, (0, types_1.asData)(types_1.bool))(function (b) {
    return (0, bool_1.pif)((0, types_1.asData)(types_1.bool)).$(b)
        .then((0, minimal_1._punsafeConvertType)((0, pData_1.pData)(new plutus_data_1.DataConstr(0, [])), (0, types_1.asData)(types_1.bool)))
        .else((0, minimal_1._punsafeConvertType)((0, pData_1.pData)(new plutus_data_1.DataConstr(1, [])), (0, types_1.asData)(types_1.bool)));
}, "pBoolToData"));
